/* ============================================================================
   SUNNY STRIPES — THE RATE CARD                                    v2026-10-11
   ----------------------------------------------------------------------------
   THIS IS THE ONLY PLACE PRICES ARE SET.

   Every quote builder on the site reads from this file. Edit a number here and
   it changes everywhere at once — the instant quote, the topdressing page, the
   aeration page, and any builder added later. Nothing else stores a price.

   Why it works this way: aeration + overseeding is sold on three different
   pages, and topdressing on two. When each page carried its own copy of the
   numbers, the same lawn could get two different prices depending on which
   page the customer landed on. It did, once — $76 on one page and $600 on
   another for the same service. One file, one answer.

   ----------------------------------------------------------------------------
   HOW THE NUMBERS READ

     tiers: [[12000,45],[25000,34],...]
       MARGINAL bands, the way tax brackets work: each rate applies ONLY to the
       square footage inside its own band. The first 12,000 sq ft is billed at
       $45 per 1,000, the next 13,000 at $34, and so on.
       This shape is deliberate. With a flat rate per band, the price FALLS as
       the lawn grows — an 11,999 sq ft lawn cost more than a 12,001 sq ft one.

     min   never quote below this, however small the lawn
     cap   never quote above this (for work that doesn't scale with lawn area)
     flat  a fixed price, ignoring lawn size

     ofService / factor
           a fixed share of ANOTHER service's curve, with its own min - used
           by `touchup`, which is a partial overseed and so should never be
           priced independently of overseeding.

   WHY THE MINIMUMS MATTER MOST
     A typical Sheboygan city lot is 3,000–7,000 sq ft of turf and lands on the
     Medium size card, which prices at 5,000. At that size the MINIMUM is what
     quotes — the per-1,000 rate never comes into play. So for most residential
     jobs the floor, not the rate, is the price. The $450 aeration + overseed
     floor is set at the premium end of the Wisconsin market on exactly that
     lot (Carl's call 2026-10-06; it was $315, Lawn Love parity).

   SNOW IS PRICED DIFFERENTLY - see the SNOW block. It is per plow, by driveway
   size, and it does not go through price(). Use snowPerPush() / snowSeason() /
   snowDepthRows().

   COMMERCIAL MAINTENANCE has its own block too, and its own assembler,
   comProgram(), which returns a whole season as line items.

   BUYING SEPARATELY MUST ALWAYS COST MORE
     `aerseed` (both) is deliberately cheaper than `aerate` + `overseed` bought
     apart, at every size. If you edit any of those three, re-check that it
     still holds at 2,500 sq ft, where all three minimums are what quote.

   ----------------------------------------------------------------------------
   ONE THING THIS FILE DOES NOT REACH ON ITS OWN: THE SHOPIFY PRODUCTS

   The quote builders read this file live, so a number changed here is changed
   on every page the moment it saves. The 13 buy-now products in the store do
   NOT work that way - Shopify keeps its own copy of every price, and a stale
   product will happily take a customer's money at last season's rate.

   AFTER CHANGING ANY NUMBER HERE, RE-SYNC THE CATALOG.
   The generator (build-products.js) reads this file and rebuilds the whole
   catalog from it, then pushes with productSet keyed on product handle.
   Variants are matched by SKU - SS-<SERVICE>-<TIER>, e.g. SS-AERSEED-M - so
   prices update in place and nothing is duplicated or orphaned. Never edit a
   SKU by hand; it is the only thing joining a product to this rate card.

   Products affected: aerseed, aerate, overseed, dethatch, topdress, fert,
   grub, cleanupSpring, cleanupFall, shrub, touchup, and mowing (both the
   per-visit and the full-season products, the latter also depending on
   MOW.seasonWeekly / seasonBiweekly). Snow and the quote-only services are
   deliberately not sold as products, so SNOW edits need no re-sync.
   ============================================================================ */
(function () {
  "use strict";

  var SERVICES = {
    /* ---- turf renovation ------------------------------------------------ */
    /* PREMIUM PRICED - Carl's call 2026-10-06. aerseed, overseed, dethatch and
       fert were raised (dethatch lowered) to sit at the premium end of the
       market. Was: aerseed 45/34/26/20 min 315; overseed 28/21/16/12.5 min 195;
       dethatch 42/31.5/24.5/19 min 225; fert 10/7.5/5.8/4.5 min 65.
       Overseeding went up only so the bundle rule below still holds. */
    aerseed:       { tiers: [[12000, 55], [25000, 40], [60000, 30], [Infinity, 23]],     min: 450,
                     label: "Core aeration + overseeding" },
    aerate:        { tiers: [[12000, 24], [25000, 18], [60000, 14], [Infinity, 11]],     min: 185,
                     label: "Core aeration" },
    overseed:      { tiers: [[12000, 33], [25000, 24], [60000, 18], [Infinity, 14]],     min: 295,
                     label: "Overseeding" },
    dethatch:      { tiers: [[12000, 30], [25000, 22.5], [60000, 17.5], [Infinity, 13.5]], min: 195,
                     label: "Dethatching" },
    /* THE TOUCH-UP IS A PARTIAL OVERSEED, so it is priced off the overseeding
       curve instead of carrying numbers of its own: 60% of what a full
       overseed of that same lawn costs, floored at $165.

       WHY THE FLOOR IS $165 AND NOT $195. Above about 10,000 sq ft the 60%
       does the work and the touch-up sits 40% under a full overseed, which is
       the rule this service is meant to express: a smaller job at a smaller
       price. Below that, both are floored by what a VISIT is worth rather
       than by seed, and 60% of a small lawn's overseeding - $117 - does not
       cover pulling the trailer out. $195 would have been the honest floor on
       cost, but it made the touch-up cost exactly the same as seeding the
       whole lawn, and a customer holding both numbers would rightly ask why
       they should take the smaller one. $165 keeps a visible 15% gap at the
       bottom of the range without pricing the visit below what it is worth.
       Carl chose it on 2026-09-01.

       It was a flat $325 until 2026-09-01, and flat broke at both ends. On a
       typical Sheboygan lot - Medium, where the minimums are what quote - a
       full overseed is $195, so the touch-up asked 167% of the whole job to
       do a fraction of it, and both numbers are published on this site for
       the same lawn. At the other end, $325 to come back and reseed the thin
       areas of a two-acre property was below the value of the trip. Carl
       chose the scaled version on 2026-09-01.

       Reading the overseed curve rather than copying it means a change to
       overseeding carries the touch-up with it.

       2026-10-06: overseeding's floor rose to $295 (premium pricing). The
       touch-up floor stays $165, so the gap at the bottom is now wider than
       the 15% described above. */
    touchup:       { ofService: "overseed", factor: 0.6, min: 165,
                     label: "Next-season touch-up overseed" },

    /* ---- topdressing ---------------------------------------------------- */
    /* PREMIUM PRICED on purpose - Carl's call 2026-09-16. Sunny Stripes is the
       only company in Sheboygan County offering topdressing as a service, so it
       is priced at about $0.35 per sq ft on a typical lawn: the low-middle of
       the $0.30-0.85 national professional range, not the contractor floor.
       Was 245/211/178/165/140/120 with an $895 minimum (about $0.21-0.25).
       Cards now: S $1,250 / M $1,750 / L $3,100 / XL $5,000 / 1/2-1ac $8,830 /
       1-3ac $20,365. Also update the starting prices hard-coded in
       snippets/ss-service-schema.liquid and templates/agents.md.liquid, and
       re-sync the SS-TOPDRESS-* product variants. */
    topdress:      { tiers: [[5000, 350], [12000, 300], [20000, 255], [50000, 235],
                             [150000, 200], [Infinity, 170]],                            min: 1250,
                     label: "Compost topdressing" },

    /* ---- watering, sold with overseeding ------------------------------ */
    /* TEMPORARY IRRIGATION for the ~4-week establishment window. Carl's call
       2026-09-16: offered only when the job includes overseeding, and never
       part of the topdressing bundle discount.

       Priced by ZONE, because the kit scales with the lawn: one sprinkler
       covers about 4,000 sq ft, and each needs 100 ft of hose (about $70 +
       $100), with a 4-way timer (about $70) per four sprinklers. The kit is
       reused, so each job recovers roughly a third of it; the rest of the
       price is setup, teardown and the check-in every couple of days, which
       costs the same whatever the lawn size. That fixed labour is why a small
       lawn carries a high price for its size.

       price = base + perZone x ceil(sqft / zoneSqft)
         Small  2,500  1 zone   $545     XL      16,500  5 zones  $945
         Medium 5,000  2 zones  $645     1/2-1ac 32,500  9 zones  $1,345
         Large  9,500  3 zones  $745
       Above maxSqft (1 acre) it is not priced online - price() returns null
       and the builders show it as quoted on site. Replaced the $495 flat
       charged on the Hullin job. Not a Shopify product. */
    irrigation:    { base: 445, perZone: 100, zoneSqft: 4000, maxSqft: 43560,
                     label: "Temporary irrigation setup" },

    /* ---- lawn care program ---------------------------------------------- */
    fert:          { tiers: [[12000, 18], [25000, 13.5], [60000, 10.5], [Infinity, 8]],  min: 125,
                     label: "Fertilization & weed control", per: "application" },
    grub:          { tiers: [[12000, 9], [25000, 6.75], [60000, 5.2], [Infinity, 4]],    min: 75,
                     label: "Grub control" },
    cleanupSpring: { tiers: [[12000, 34], [25000, 25.5], [60000, 20], [Infinity, 15]],   min: 195,
                     label: "Spring cleanup" },
    cleanupFall:   { tiers: [[12000, 44], [25000, 33], [60000, 25.5], [Infinity, 20]],   min: 245,
                     label: "Fall cleanup" },

    /* ---- work that does not scale with lawn area ------------------------- */
    shrub:         { per1000: 28, min: 150, cap: 450,  label: "Shrub & bush trimming" },

    /* Snow is NOT here. It is priced by DRIVEWAY size, not lawn size - see the
       SNOW block below. It used to sit here at $30 per 1,000 sq ft of lawn with
       a $475 floor, which quoted a customer $475 on the instant quote while the
       snow page quoted the same driveway $580. Lawn area is a bad proxy for
       driveway area: a small house on a big lot has a short drive, and a big
       house on a small lot often has a long one. */

    /* ---- quote-only: no rate, flagged for a human ------------------------ */
    /* Mulch and decorative rock are NOT priced here on purpose. The material
       is the price — single-ground hardwood, dyed black, cedar, river rock,
       granite chip and limestone are nowhere near each other per yard, and
       the bed prep varies as much as the material. Both were briefly carried
       at a flat $115 / $165 per yard; that produced quotes that were wrong in
       both directions depending on what the customer actually wanted. */
    mulch:         { quoteOnly: true, label: "Mulch installation" },
    rock:          { quoteOnly: true, label: "Decorative rock installation" },
    hydroseed:     { quoteOnly: true, label: "Hydroseeding" }
  };

  /* Mowing is a per-visit curve rather than a per-1,000 rate: points are
     [acres, $ per visit], interpolated, with topSlope $/acre beyond the last. */
  var MOW = {
    /* THE CURVE - Carl's call 2026-10-11, after a market check. Each point
       sits on a size card's turf area, so the cards read:
         Small $65 / Medium $75 / Large $85 / Extra Large $95 /
         1/2-1 acre $115 (at 0.75) / 1-3 acres $190 (at 2)
       $10 a step up to three quarters of an acre, then $60 an acre.

       Why: Small and Medium both read $65 before, and Large only $70, so a
       bigger yard barely cost more. Real quotes on 2026-10-11 put Lawn Love at
       $69.09 and LawnStarter at $68.04 a cut (with their $3.99 fee) on a 0.16
       acre lot in Sheboygan Falls, so Medium at $75 is a modest premium over
       the national platforms. Local survey ranges (HomeBlue) run lower,
       $42-58 for a quarter acre - those are solo operators.

       Was [[0.0574,50],[0.1148,65],[0.35,80],[0.86,110]] with topSlope 70.
       2 acres stays $190, where Carl put it on 2026-10-09; 3 acres drops
       from $260 to $250.

       min 65 - NO YARD UNDER $65 A VISIT. Carl's floor, 2026-10-09. The curve
       now starts at $65 itself, so the floor only matters below the Small
       card's area. Applied before the biweekly premium. */
    curve: [[0.0574, 65], [0.1148, 75], [0.218, 85], [0.379, 95], [0.746, 115]], topSlope: 60,
    min: 65,
    /* How many cuts a Sheboygan season holds, mid-April to late October. This
       is a fact about the weather, not about the customer, so it lives here and
       the commercial block borrows it rather than keeping a second copy - two
       copies of a season length is how the same lawn ends up with two different
       season prices. Used by the season mowing products and by comProgram(). */
    seasonWeekly: 28,
    seasonBiweekly: 14,

    /* EVERY-OTHER-WEEK COSTS MORE PER VISIT. Two weeks of growth is a slower
       cut, a heavier load and more clippings to deal with, so a biweekly visit
       is priced at 1.30x the weekly one. Carl confirmed the 30% on 2026-09-01.

       It is applied to the RAW curve and rounded once, like everything else:
       $71.59 x 1.30 = $93.07 -> $95. That is why a Large lawn reads as 36%
       rather than 30% - the weekly figure rounds down and the biweekly one
       rounds up. Rounding the weekly price first and then applying the premium
       would keep the percentage tidier and is exactly the double-rounding that
       produced the $1,565/$1,560 and $103/$105 defects. The percentage is an
       internal rate, not a published claim; the customer only ever sees two
       prices.

       This lived inside the instant quote's own code until 2026-09-01, which
       is why the full-season BIWEEKLY products were built at the weekly rate -
       14 x $70 instead of 14 x $95 on a Large lawn, a $350 hole per season
       that nothing on the site disagreed with, because only one side knew the
       premium existed. It is here now so both sides read the same number. */
    biweeklyPremium: 1.30
  };

  /* ==========================================================================
     COMMERCIAL MAINTENANCE - the grounds program for businesses, apartment
     complexes, HOAs and campuses. Set 2026-08-31.

     WHY COMMERCIAL NEEDS ITS OWN NUMBERS AT ALL
     Most of the program reuses the residential rates above, on purpose: an
     acre of turf takes the same fertiliser and the same leaf raking whoever
     owns it. Only the things that genuinely differ are re-set here.

     mowSlope 85 (residential is 60)
       Above the last curve point the residential slope assumes open, simple
       acreage - a big back lawn you can run in long passes. Commercial acreage
       is not that shape. It is broken up by parking islands, light poles,
       bollards, sign beds, fire lanes and curb returns, and the trimming
       around them is what actually eats the hour, not the mowing. Carl chose
       $95/acre on 2026-08-31 from a choice of 70 / 95 / 120. It went to $145
       on 2026-10-06 alongside the residential raise, and back to $95 with it on
       2026-10-09 - still $25 above residential. On 2026-10-11 the residential
       curve was reshaped (its last point moved to 0.746 acres, slope 60), so
       this went to $85 to keep 2 acres at $220 a visit against $190.

     mowMin 75
       A commercial stop carries overhead a residential one does not: a
       certificate of insurance, a named schedule, an invoice that goes to a
       property manager rather than a homeowner. The residential curve quotes
       a small storefront's 6,000 sq ft at about $66, which does not cover the
       stop. 75 is the floor for pulling the trailer onto a commercial site.

     bedPer1000 / bedMin - bed care is priced on MEASURED BED AREA
       Residential `shrub` is a proxy: dollars per 1,000 sq ft of LAWN, capped
       at $450. Both halves of that are wrong here. The commercial builder has
       the customer draw the beds, so it can price the actual thing, and the
       cap would bind on the first real property and quote a corporate campus
       the same as a dentist's office.
       bedMin is 85, not 150, because the crew is already on site for the mow -
       150 is a price for making a special trip.

     treeLeafAdd 18
       The honest weakness in quoting a fall cleanup off turf area: leaves fall
       from trees, not from grass. Two identical acres, one bare and one under
       forty maples, are not the same job. So the builder has the customer drop
       a pin on each mature tree and this adds per tree to the FALL cleanup
       only - never to spring, which is about winter debris and not leaf load.

     maxAcres 3
       Above three acres this stops quoting and asks for a walk. That is the
       same ceiling the TIERS list already uses, and it is where the job stops
       being a route stop and becomes a bid with a mobilisation plan.
     ========================================================================== */
  var COMMERCIAL = {
    mowSlope:      85,   /* $ per acre above the residential curve's last point */
    mowMin:        75,   /* smallest commercial mowing visit */
    visitsWeekly:  MOW.seasonWeekly,     /* the season length lives in MOW */
    visitsBiweekly: MOW.seasonBiweekly,
    fertRounds:     5,   /* applications in a commercial season program */
    bedPer1000:    85,   /* bed care per visit, on measured BED area */
    bedMin:        85,
    bedVisits:      8,   /* bed visits across the season, roughly monthly */
    treeLeafAdd:   18,   /* per marked mature tree, added to the fall cleanup only */
    billMonths:     8,   /* the season spread into equal invoices, Apr-Nov */
    maxAcres:       3    /* above this we quote by hand, not online */
  };

  /* ==========================================================================
     BULK MATERIALS ARE NOT PRICED HERE - AND THAT IS DELIBERATE.

     Mulch, screened topsoil, decorative stone and compost are sold by the yard
     or the ton on /pages/bulk-material-delivery, and their prices - along with
     the flat $75 delivery fee, the second-trip surcharge, the spreading labour
     and the bed-prep rate - live in the RATES block at the top of
     assets/materials-quote.js.

     They stay there because nothing else on the site quotes them. The rule this
     rate card enforces is ONE HOME PER PRICE, not one file for every price: the
     $76-versus-$600 incident that created this file happened because the SAME
     service was priced in two places, and copying the material list here would
     manufacture exactly that risk for no benefit.

     The one adjacent thing that IS here: `topdress` in SERVICES above prices
     compost topdressing as a SERVICE, by lawn area, spread a quarter inch thick
     over a whole lawn. That is a different job from a yard of compost tipped on
     a driveway, and it is why the bulk page points lawn-topdressing customers
     at /pages/topdressing instead of selling them eight yards to spread.
     ========================================================================== */

  /* ==========================================================================
     SNOW & ICE - priced per PLOW, by driveway size, not by lawn area.

     PRICING BASIS (Aug 2026, raised 2026-08-31)
       Per-visit residential driveway   national $30-75 typical; Angi average
                                        visit $126, range $51-203
       Seasonal residential contract    national $300-700 (Angi: 1-car $300-400,
                                        2-car $400-600, 4-car $600-1,000)
       Salting / de-icing               $10-60 per application
       Walks and steps                  $10-30 per visit

     Carl set the per-push floor at $60 and the 3-car at $110 on 2026-08-31.
     Those sit mid-range against the Angi per-visit band ($51-203) and are a
     deliberate move up from the $45/$55/$75/$110 this launched with. The 2-car
     ($85) and the long/rural drive ($160) are interpolated to keep the cost
     per square foot falling as the driveway grows - $0.17, $0.14, $0.10, $0.08
     - which is the right shape, because mobilization is a fixed cost that a
     small driveway has to carry on its own.

     SNOW IS PRICED TO BE A SMALL, WELL-PAID LINE - NOT TO WIN VOLUME.
     Carl does not want a lot of snow work: it is 24/7 on-call in a way lawn
     care is not, and his time is worth more than a thin plough margin. Being
     at the top of the market is the point, not a problem. Both these numbers
     and the seasonal premium sit above the national bands deliberately. If a
     future edit is justified as "we need to be more competitive on snow",
     that edit is arguing with the strategy, not fixing a mistake.

     Seasonal is DERIVED from per-push, so raising per-push raises it too. If
     the seasonal sticker ever needs to move, the lever is the per-push price
     or seasonPremium - never seasonPushes, which is a fact about the weather
     and not a dial.

     THE NUMBER THAT DECIDES EVERYTHING is seasonPushes - how many times we
     actually plow. Milwaukee (nearest first-order station, 48.7 in/yr, same
     lakeshore climate as Sheboygan) averages 13.6 days/yr at 1 in+, 5.0 days at
     3 in+, 2.1 days at 5 in+. At our 2 in trigger that interpolates to roughly
     8-9 qualifying days, and real service runs a little higher because long
     storms get pushed twice. 10 is the working figure. A light winter is 6, a
     bad one is 14+. If that number is wrong, every seasonal contract is wrong.

     SALT IS NEVER IN THE SEASONAL PRICE. A mild icy winter and a snowy dry one
     need wildly different amounts, and nobody should prepay for salt they may
     not need. It is billed per application, on both plans.
     ========================================================================== */
  var SNOW = {
    /* Per-push price by driveway size, at the base 2-6 in depth band. */
    drives: [
      { k: "d1", nm: "1-car / short",    sz: "Up to ~400 sq ft",   sqft: 350,  push: 60,
        hint: "Single stall, a car length or two to the street" },
      { k: "d2", nm: "2-car",            sz: "~400-800 sq ft",     sqft: 600,  push: 85,
        hint: "The most common driveway around here" },
      { k: "d3", nm: "3-car / extended", sz: "~800-1,400 sq ft",   sqft: 1100, push: 110,
        hint: "Wide apron, turnaround, or an extra parking pad" },
      { k: "d4", nm: "Long or rural",    sz: "~1,400-2,500 sq ft", sqft: 1900, push: 160,
        hint: "Country drive, a hundred feet or more to the road" },
      { k: "d5", nm: "Extra long",       sz: "2,500+ sq ft",       sqft: null, push: null, custom: true,
        hint: "We'll measure this one and put a fixed price in writing" }
    ],

    trigger:   2,    /* inches of accumulation before we roll - automatic, no call */
    walks:     20,   /* walks + steps, per visit */
    saltDrive: 35,   /* per application - always billed separately */
    saltWalks: 20,

    /* Deeper snow is slower and harder on equipment, so the per-visit price
       steps up with accumulation. Multipliers apply to the PLOWING price only,
       never to walks and never to salt - a deep storm does not make the
       sidewalk longer or the salt heavier.

       Three priced bands, set 2026-08-31. Before that there were two (2-6" at
       base, 6-12" at +40%), which billed a 5" storm at the same rate as a 2"
       one - the moderate storm we actually get most often was the one being
       given away. The crew has to note the depth for this to be worth having.

       A band with mult:null is not priced online at all. Twelve inches is not
       a driveway job with a surcharge, it is a different job. */
    depthBands: [
      { upTo: 4,        mult: 1.00, label: '2-4"',  note: "a light storm" },
      { upTo: 8,        mult: 1.15, label: '4-8"',  note: "the usual around here" },
      { upTo: 12,       mult: 1.40, label: '8-12"', note: "slower going, two passes" },
      { upTo: Infinity, mult: null, label: '12"+',  note: "we price it on the day", custom: true }
    ],

    /* SEASONAL IS DEPTH-BLIND ON PURPOSE. It is priced off the BASE band, so a
       bad winter of deep storms costs the seasonal customer nothing extra -
       that is the whole product. Depth pricing applies to per-visit only. */
    seasonPushes:  10,   /* expected plowable snowfalls - see the header note */

    /* WHY THE SEASONAL PREMIUM IS 1.30 AND NOT SOMETHING FRIENDLIER.
       A seasonal contract is us selling insurance: the customer's price is
       fixed and OUR labour is not. In a heavy winter we plow 14 times for the
       price of 10.5. That is a bad trade for a business that does not want
       more snow work and does not want to be on call all winter - which is
       exactly this business. Snow is deliberately the smaller, higher-priced
       line here; lawn care is the work that can be scheduled.

       So seasonal is priced as real insurance, not as a discount. At 1.30 the
       break-even lands on the 13th visit at every driveway size: above a
       normal winter (10), below a genuinely brutal one, so the customer who
       buys it still comes out ahead when the winter is bad. That is honest,
       and it means most people will sensibly choose per-visit - the plan where
       we are paid for every hour we actually work.

       Do NOT drop this back toward 1.0 to sell more seasonal contracts. The
       tool shows the customer the break-even either way; a cheap seasonal
       price does not hide the maths, it just gives away the risk premium. */
    seasonPremium: 1.30,

    /* Visits included before we have to talk again. Was 20, which at a 2-car
       driveway meant up to $1,700 of plowing for $1,105 - the tail risk the
       premium is supposed to cover, uncovered. 15 sits just past a heavy
       winter (14), so it almost never binds, and caps the extreme year. */
    seasonCap:     15,
    seasonLight:    6,   /* a light Sheboygan winter */
    seasonHeavy:   14    /* a heavy one */
  };

  function driveBy(k) {
    for (var i = 0; i < SNOW.drives.length; i++) {
      if (SNOW.drives[i].k === k) return SNOW.drives[i];
    }
    return SNOW.drives[1];   /* 2-car is the default around here */
  }

  /* One plow visit at the base depth band. Returns null for the custom size. */
  function snowPerPush(driveKey, withWalks) {
    var d = driveBy(driveKey);
    if (d.custom) return null;
    return d.push + (withWalks ? SNOW.walks : 0);
  }

  /* A whole winter, plowing and walks. Salt is never included. */
  function snowSeason(driveKey, withWalks) {
    var per = snowPerPush(driveKey, withWalks);
    if (per == null) return null;
    return Math.round((per * SNOW.seasonPushes * SNOW.seasonPremium) / 5) * 5;
  }

  /* Every depth band for a driveway, as rows a tool can render without knowing
     anything about how depth pricing works. `price` is null on a band we quote
     by hand. Walks are added ONCE per visit and are never multiplied by depth. */
  function snowDepthRows(driveKey, withWalks) {
    var d = driveBy(driveKey);
    if (d.custom) return null;
    var walks = withWalks ? SNOW.walks : 0;
    var rows = [], i, b;
    for (i = 0; i < SNOW.depthBands.length; i++) {
      b = SNOW.depthBands[i];
      rows.push({
        label:  b.label,
        note:   b.note,
        custom: !!b.custom,
        price:  b.mult == null ? null : Math.round((d.push * b.mult + walks) / 5) * 5
      });
    }
    return rows;
  }

  /* Size cards, as TURF square footage. Shared so "Large" means the same lawn
     on every page. */
  var TIERS = [
    { k: "s",  nm: "Small",       sz: "Up to ~3,000 sq ft",    area: 2500,
      res: "Townhome / small city lot", com: "Small storefront / office" },
    { k: "m",  nm: "Medium",      sz: "~3,000–7,000 sq ft",    area: 5000,
      res: "Typical suburban lot",      com: "Standard business property" },
    { k: "l",  nm: "Large",       sz: "~7,000–12,000 sq ft",   area: 9500,
      res: "Big / corner lot",          com: "Large commercial lot" },
    { k: "xl", nm: "Extra Large", sz: "12,000 sq ft – ½ acre", area: 16500,
      res: "Estate lot",                com: "Extra-large commercial lot" },
    { k: "a1", nm: "½ – 1 acre",  sz: "~22,000–43,000 sq ft",  area: 32500,
      res: "Priced per acre",           com: "Priced per acre" },
    { k: "a3", nm: "1 – 3 acres", sz: "Up to ~3 acres",        area: 87120,
      res: "Priced per acre",           com: "Priced per acre" },
    { k: "xx", nm: "3+ acres",    sz: "Large parcel",          area: null, custom: true,
      res: "We'll build a custom quote", com: "We'll build a custom quote" }
  ];

  function marginal(tiers, sqft) {
    var total = 0, prev = 0;
    for (var i = 0; i < tiers.length; i++) {
      total += Math.max(0, Math.min(sqft, tiers[i][0]) - prev) / 1000 * tiers[i][1];
      prev = tiers[i][0];
      if (sqft <= tiers[i][0]) break;
    }
    return total;
  }

  /* price("aerseed", 5000) -> 450. Returns null for quote-only services and
     for a service key that does not exist, so a typo shows as a missing price
     rather than a wrong one. */
  function price(key, sqft) {
    var c = SERVICES[key];
    if (!c || c.quoteOnly) return null;
    if (c.flat != null) return c.flat;
    if (c.perZone) {
      /* Zone-priced - see `irrigation`. Null past the online ceiling. */
      if (c.maxSqft && sqft > c.maxSqft) return null;
      return c.base + c.perZone * Math.ceil(sqft / c.zoneSqft);
    }
    var v;
    if (c.ofService) {
      /* A fixed share of another service's curve - see `touchup`. This reads
         the BASIS CURVE and not the basis's minimum, so the two floors stay
         independent and nothing is floored twice. */
      var b = SERVICES[c.ofService];
      v = (b.tiers ? marginal(b.tiers, sqft) : (b.per1000 || 0) * sqft / 1000) * c.factor;
    } else {
      v = c.tiers ? marginal(c.tiers, sqft) : (c.per1000 || 0) * sqft / 1000;
    }
    v = Math.max(c.min || 0, v);
    return c.cap ? Math.min(c.cap, v) : v;
  }

  /* Per-visit mowing price for a given acreage. Pass commercial=true for the
     steeper slope and the commercial floor - see the COMMERCIAL block. The
     curve itself is shared: below three quarters of an acre a business lawn
     and a house lawn are the same mow. */
  function mowPerVisit(acres, commercial) {
    var pts = MOW.curve;
    var v;
    if (acres <= pts[0][0]) {
      v = pts[0][1];
    } else {
      v = null;
      for (var i = 0; i < pts.length - 1; i++) {
        if (acres <= pts[i + 1][0]) {
          var x0 = pts[i][0], y0 = pts[i][1], x1 = pts[i + 1][0], y1 = pts[i + 1][1];
          v = y0 + (y1 - y0) * (acres - x0) / (x1 - x0);
          break;
        }
      }
      if (v == null) {
        var last = pts[pts.length - 1];
        v = last[1] + (commercial ? COMMERCIAL.mowSlope : MOW.topSlope) * (acres - last[0]);
      }
    }
    return Math.max(commercial ? COMMERCIAL.mowMin : MOW.min, v);
  }

  /* --------------------------------------------------------------------------
     A WHOLE COMMERCIAL SEASON, as line items a builder can render without
     knowing a single price.

     Give it what the customer drew and ticked:
       { turfSqft, bedSqft, trees, frequency:"weekly"|"biweekly",
         services:{ mow:true, beds:true, fert:true, cleanups:true } }

     Get back { custom, lines[], season, monthly, months, acres, visits }.
     `custom:true` means the property is past maxAcres and nothing is quoted -
     render the site-walk path instead, the same way the snow tool handles an
     extra-long driveway.

     Every figure is rounded to $5 here rather than in the builder, so the page,
     the lead email and the recap can never disagree by a rounding step.
     -------------------------------------------------------------------------- */
  function round5(n) { return Math.round(n / 5) * 5; }

  function comProgram(o) {
    o = o || {};
    var turf  = Math.max(0, o.turfSqft || 0);
    var beds  = Math.max(0, o.bedSqft  || 0);
    var trees = Math.max(0, o.trees    || 0);
    var acres = turf / 43560;
    var want  = o.services || {};
    var weekly = o.frequency !== "biweekly";
    var visits = weekly ? COMMERCIAL.visitsWeekly : COMMERCIAL.visitsBiweekly;

    if (acres > COMMERCIAL.maxAcres) {
      return { custom: true, lines: [], season: null, monthly: null,
               months: COMMERCIAL.billMonths, acres: acres, visits: visits };
    }

    var lines = [];

    if (want.mow && turf > 0) {
      var m = round5(mowPerVisit(acres, true));
      lines.push({ key: "mow", label: "Mowing, trimming & edging",
                   detail: visits + (weekly ? " weekly visits" : " visits, every other week"),
                   each: m, count: visits, total: m * visits });
    }

    if (want.beds && beds > 0) {
      var b = round5(Math.max(COMMERCIAL.bedMin, COMMERCIAL.bedPer1000 * beds / 1000));
      lines.push({ key: "beds", label: "Bed care, shrub trimming & edging",
                   detail: COMMERCIAL.bedVisits + " visits across the season",
                   each: b, count: COMMERCIAL.bedVisits, total: b * COMMERCIAL.bedVisits });
    }

    if (want.fert && turf > 0) {
      var f = round5(price("fert", turf));
      lines.push({ key: "fert", label: "Fertilization & weed control",
                   detail: COMMERCIAL.fertRounds + " applications, timed to our season",
                   each: f, count: COMMERCIAL.fertRounds, total: f * COMMERCIAL.fertRounds });
    }

    if (want.cleanups && turf > 0) {
      var sp = round5(price("cleanupSpring", turf));
      lines.push({ key: "cleanupSpring", label: "Spring cleanup",
                   detail: "once, at green-up", each: sp, count: 1, total: sp });
      /* The tree count is the whole reason this number is worth quoting. */
      var fa = round5(price("cleanupFall", turf) + trees * COMMERCIAL.treeLeafAdd);
      lines.push({ key: "cleanupFall", label: "Fall cleanup",
                   detail: trees
                     ? ("once, after leaf drop · " + trees + " tree" + (trees === 1 ? "" : "s") + " marked")
                     : "once, after leaf drop",
                   each: fa, count: 1, total: fa });
    }

    var season = 0;
    for (var i = 0; i < lines.length; i++) season += lines[i].total;

    return {
      custom: false, lines: lines, season: season,
      monthly: season ? round5(season / COMMERCIAL.billMonths) : 0,
      months: COMMERCIAL.billMonths, acres: acres, visits: visits
    };
  }

  window.SS_RATES = {
    version: "2026-10-11",
    services: SERVICES,
    mow: MOW,
    snow: SNOW,
    commercial: COMMERCIAL,
    tiers: TIERS,
    /* Booking topdressing alongside core aeration + overseeding takes 10% off
       the pair.

       THIS FIGURE IS PRINTED ON THE SITE, so it has to move when it changes.
       The quote tools now render it from here - see PUBLISHED FIGURES at the
       bottom of this file - so the tool snippets look after themselves. TWO
       places do NOT, because they are marketing prose you edit in the theme
       editor rather than code:

         templates/page.aeration-overseeding.json
           multicolumn "column_topdress"        "...Book both together and save 10%."
           FAQ row "collapsible_row_topdress"   "...and we discount the pair 10%."

       Change bundleDiscount and those two sentences need changing by hand. */
    bundleDiscount: 0.10,
    price: price,
    mowPerVisit: mowPerVisit,
    snowDrive: driveBy,
    snowPerPush: snowPerPush,
    snowSeason: snowSeason,
    snowDepthRows: snowDepthRows,
    comProgram: comProgram,
    round5: round5,
    /* True when the minimum is what quoted, rather than the rate. */
    atMin: function (key, sqft) {
      var c = SERVICES[key];
      return !!(c && c.min && price(key, sqft) <= c.min);
    },

    /* ========================================================================
       PUBLISHED FIGURES - numbers this card states in prose on the pages.

       A price typed into HTML is a price nobody remembers to change. It has
       already happened twice: a "$325 flat" touch-up tile on two different
       pages went on advertising $325 after the touch-up started scaling with
       lawn size, and the snow disclaimer promised a 20-visit season cap for
       months after the cap became 15.

       So any figure this card publishes in a sentence is written into the page
       like this:

         the pair is discounted <span data-ss-rate="bundlePct">10</span>%

       The literal inside the span is only what shows before scripts run; the
       value below is what the reader ends up with. Add a figure here the day
       you put it in a sentence, not after it goes stale.
       ==================================================================== */
    published: {
      /* Read back off the card rather than restating 0.10 - a published
         figure that keeps its own copy of the number is the whole problem
         this block exists to solve. */
      bundlePct:       function () { return Math.round(window.SS_RATES.bundleDiscount * 100); },
      snowTrigger:     function () { return SNOW.trigger; },
      snowPushes:      function () { return SNOW.seasonPushes; },
      snowCap:         function () { return SNOW.seasonCap; },
      snowLight:       function () { return SNOW.seasonLight; },
      snowHeavy:       function () { return SNOW.seasonHeavy; },
      mowBiweeklyPct:  function () { return Math.round((MOW.biweeklyPremium - 1) * 100); },
      mowSeasonWeekly: function () { return MOW.seasonWeekly; },
      mowSeasonBiwk:   function () { return MOW.seasonBiweekly; }
    },

    /* Fills every [data-ss-rate] on the page. Unknown keys are left alone
       rather than blanked - a typo in a data attribute should leave the
       hard-coded fallback showing, not an empty gap in a sentence. */
    fillPage: function (root) {
      var pub = window.SS_RATES.published;
      var els = (root || document).querySelectorAll("[data-ss-rate]");
      for (var i = 0; i < els.length; i++) {
        var k = els[i].getAttribute("data-ss-rate");
        if (typeof pub[k] === "function") els[i].textContent = String(pub[k]());
      }
      return els.length;
    }
  };

  /* Run it once the markup exists. Every page that prices anything already
     loads this file, so nothing else has to opt in. */
  if (typeof document !== "undefined") {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () { window.SS_RATES.fillPage(); });
    } else {
      window.SS_RATES.fillPage();
    }
  }
})();